import {Notice} from './partial/notice'

export const SubBundleType = {
    /** 일반 */
    NORMAL: 'NORMAL',
    /** 배송있음 */
    DELIVERY: 'DELIVERY',
    /** 하위 가맹점 */
    SUB_MERCHANT: 'SUB_MERCHANT',
} as const

type BaseSubBundle<Type extends Constant<typeof SubBundleType>, Extra = undefined> = {
    /** 번들키 */
    bundleKey: string
    type: Type
    /** 안내 */
    notices?: Notice[]
} & ConditionalField<Extra, 'extra'>

type DeliverySubBundle = BaseSubBundle<
    typeof SubBundleType.DELIVERY,
    {
        delivery: {
            /** 배송비 */
            fee: number
            /** 배송비 결제 타입 */
            paymentType: Constant<typeof DeliveryPaymentType>
            /** 해외 배송 여부 */
            isOversea: boolean
            /** 배송 안내 타입 */
            noticeType?: Constant<typeof DeliveryNoticeType>
        }
    }
>

type SubMerchantSubBundle = BaseSubBundle<
    typeof SubBundleType.SUB_MERCHANT,
    {
        /** 하위 가맹점 정보 */
        subMerchant: {
            /** 이름 */
            name?: string
            /** URL */
            homeUrl?: string
        }
    }
>

export type SubBundle = BaseSubBundle<typeof SubBundleType.NORMAL> | DeliverySubBundle | SubMerchantSubBundle

/** 배송 안내 타입 */
export const DeliveryNoticeType = {
    /** 추가 배송비 안내 툴팁 */
    EXTRA_DELIVERY_FEE_TOOLTIP: 'EXTRA_DELIVERY_FEE_TOOLTIP',
} as const

/** 배송비 결제 타입 */
export const DeliveryPaymentType = {
    /** 선불 */
    PREPAID: 'PREPAID',
    /** 착불 */
    CASH_ON_DELIVERY: 'CASH_ON_DELIVERY',
    /** 무료 */
    FREE: 'FREE',
    /** 직거래 */
    DIRECT: 'DIRECT',
    /** 알수 없음 */
    UNKNOWN: 'UNKNOWN',
} as const

export type DeliveryPaymentTypes = Constant<typeof DeliveryPaymentType>
